export const countries = [
  {
    country: 'Afghanistan',
    alpha2: 'AF',
    alpha3: 'AFG',
    numeric: '4',
    code: '+93',
  },
  {
    country: 'Albania',
    alpha2: 'AL',
    alpha3: 'ALB',
    numeric: '8',
    code: '+355',
  },
  {
    country: 'Algeria',
    alpha2: 'DZ',
    alpha3: 'DZA',
    numeric: '12',
    code: '+213',
  },
  {
    country: 'American Samoa',
    alpha2: 'AS',
    alpha3: 'ASM',
    numeric: '16',
    code: '+1684',
  },
  {
    country: 'Andorra',
    alpha2: 'AD',
    alpha3: 'AND',
    numeric: '20',
    code: '+376',
  },
  {
    country: 'Angola',
    alpha2: 'AO',
    alpha3: 'AGO',
    numeric: '24',
    code: '+244',
  },
  {
    country: 'Anguilla',
    alpha2: 'AI',
    alpha3: 'AIA',
    numeric: '660',
    code: '+1264',
  },
  {
    country: 'Antarctica',
    alpha2: 'AQ',
    alpha3: 'ATA',
    numeric: '10',
    code: '+672',
  },
  {
    country: 'Antigua and Barbuda',
    alpha2: 'AG',
    alpha3: 'ATG',
    numeric: '28',
    code: '+1268',
  },
  {
    country: 'Argentina',
    alpha2: 'AR',
    alpha3: 'ARG',
    numeric: '32',
    code: '+54',
  },
  {
    country: 'Armenia',
    alpha2: 'AM',
    alpha3: 'ARM',
    numeric: '51',
    code: '+374',
  },
  {
    country: 'Aruba',
    alpha2: 'AW',
    alpha3: 'ABW',
    numeric: '533',
    code: '+297',
  },
  {
    country: 'Australia',
    alpha2: 'AU',
    alpha3: 'AUS',
    numeric: '36',
    code: '+61',
  },
  {
    country: 'Austria',
    alpha2: 'AT',
    alpha3: 'AUT',
    numeric: '40',
    code: '+43',
  },
  {
    country: 'Azerbaijan',
    alpha2: 'AZ',
    alpha3: 'AZE',
    numeric: '31',
    code: '+994',
  },
  {
    country: 'Bahamas (the)',
    alpha2: 'BS',
    alpha3: 'BHS',
    numeric: '44',
    code: '+1242',
  },
  {
    country: 'Bahrain',
    alpha2: 'BH',
    alpha3: 'BHR',
    numeric: '48',
    code: '+973',
  },
  {
    country: 'Bangladesh',
    alpha2: 'BD',
    alpha3: 'BGD',
    numeric: '50',
    code: '+880',
  },
  {
    country: 'Barbados',
    alpha2: 'BB',
    alpha3: 'BRB',
    numeric: '52',
    code: '+1246',
  },
  {
    country: 'Belarus',
    alpha2: 'BY',
    alpha3: 'BLR',
    numeric: '112',
    code: '+375',
  },
  {
    country: 'Belgium',
    alpha2: 'BE',
    alpha3: 'BEL',
    numeric: '56',
    code: '+32',
  },
  {
    country: 'Belize',
    alpha2: 'BZ',
    alpha3: 'BLZ',
    numeric: '84',
    code: '+501',
  },
  {
    country: 'Benin',
    alpha2: 'BJ',
    alpha3: 'BEN',
    numeric: '204',
    code: '+229',
  },
  {
    country: 'Bermuda',
    alpha2: 'BM',
    alpha3: 'BMU',
    numeric: '60',
    code: '+1441',
  },
  {
    country: 'Bhutan',
    alpha2: 'BT',
    alpha3: 'BTN',
    numeric: '64',
    code: '+975',
  },
  {
    country: 'Bolivia (Plurinational State of)',
    alpha2: 'BO',
    alpha3: 'BOL',
    numeric: '68',
    code: '+591',
  },
  {
    country: 'Bonaire, Sint Eustatius and Saba',
    alpha2: 'BQ',
    alpha3: 'BES',
    numeric: '535',
    code: '+599',
  },
  {
    country: 'Bosnia and Herzegovina',
    alpha2: 'BA',
    alpha3: 'BIH',
    numeric: '70',
    code: '+387',
  },
  {
    country: 'Botswana',
    alpha2: 'BW',
    alpha3: 'BWA',
    numeric: '72',
    code: '+267',
  },
  {
    country: 'Bouvet Island',
    alpha2: 'BV',
    alpha3: 'BVT',
    numeric: '74',
    code: '+47',
  },
  {
    country: 'Brazil',
    alpha2: 'BR',
    alpha3: 'BRA',
    numeric: '76',
    code: '+55',
  },
  {
    country: 'British Indian Ocean Territory (the)',
    alpha2: 'IO',
    alpha3: 'IOT',
    numeric: '86',
    code: '+246',
  },
  {
    country: 'Brunei Darussalam',
    alpha2: 'BN',
    alpha3: 'BRN',
    numeric: '96',
    code: '+673',
  },
  {
    country: 'Bulgaria',
    alpha2: 'BG',
    alpha3: 'BGR',
    numeric: '100',
    code: '+359',
  },
  {
    country: 'Burkina Faso',
    alpha2: 'BF',
    alpha3: 'BFA',
    numeric: '854',
    code: '+226',
  },
  {
    country: 'Burundi',
    alpha2: 'BI',
    alpha3: 'BDI',
    numeric: '108',
    code: '+257',
  },
  {
    country: 'Cabo Verde',
    alpha2: 'CV',
    alpha3: 'CPV',
    numeric: '132',
    code: '+238',
  },
  {
    country: 'Cambodia',
    alpha2: 'KH',
    alpha3: 'KHM',
    numeric: '116',
    code: '+855',
  },
  {
    country: 'Cameroon',
    alpha2: 'CM',
    alpha3: 'CMR',
    numeric: '120',
    code: '+237',
  },
  {
    country: 'Canada',
    alpha2: 'CA',
    alpha3: 'CAN',
    numeric: '124',
    code: '+1',
  },
  {
    country: 'Cayman Islands (the)',
    alpha2: 'KY',
    alpha3: 'CYM',
    numeric: '136',
    code: '+1345',
  },
  {
    country: 'Central African Republic (the)',
    alpha2: 'CF',
    alpha3: 'CAF',
    numeric: '140',
    code: '+236',
  },
  {
    country: 'Chad',
    alpha2: 'TD',
    alpha3: 'TCD',
    numeric: '148',
    code: '+235',
  },
  {
    country: 'Chile',
    alpha2: 'CL',
    alpha3: 'CHL',
    numeric: '152',
    code: '+56',
  },
  {
    country: 'China',
    alpha2: 'CN',
    alpha3: 'CHN',
    numeric: '156',
    code: '+86',
  },
  {
    country: 'Christmas Island',
    alpha2: 'CX',
    alpha3: 'CXR',
    numeric: '162',
    code: '+61',
  },
  {
    country: 'Cocos (Keeling) Islands (the)',
    alpha2: 'CC',
    alpha3: 'CCK',
    numeric: '166',
    code: '+61',
  },
  {
    country: 'Colombia',
    alpha2: 'CO',
    alpha3: 'COL',
    numeric: '170',
    code: '+57',
  },
  {
    country: 'Comoros (the)',
    alpha2: 'KM',
    alpha3: 'COM',
    numeric: '174',
    code: '+269',
  },
  {
    country: 'Congo (the Democratic Republic of the)',
    alpha2: 'CD',
    alpha3: 'COD',
    numeric: '180',
    code: '+243',
  },
  {
    country: 'Congo (the)',
    alpha2: 'CG',
    alpha3: 'COG',
    numeric: '178',
    code: '+242',
  },
  {
    country: 'Cook Islands (the)',
    alpha2: 'CK',
    alpha3: 'COK',
    numeric: '184',
    code: '+682',
  },
  {
    country: 'Costa Rica',
    alpha2: 'CR',
    alpha3: 'CRI',
    numeric: '188',
    code: '+506',
  },
  {
    country: 'Croatia',
    alpha2: 'HR',
    alpha3: 'HRV',
    numeric: '191',
    code: '+385',
  },
  {
    country: 'Cuba',
    alpha2: 'CU',
    alpha3: 'CUB',
    numeric: '192',
    code: '+53',
  },
  {
    country: 'Curaçao',
    alpha2: 'CW',
    alpha3: 'CUW',
    numeric: '531',
    code: '+599',
  },
  {
    country: 'Cyprus',
    alpha2: 'CY',
    alpha3: 'CYP',
    numeric: '196',
    code: '+357',
  },
  {
    country: 'Czechia',
    alpha2: 'CZ',
    alpha3: 'CZE',
    numeric: '203',
    code: '+420',
  },
  {
    country: "Côte d'Ivoire",
    alpha2: 'CI',
    alpha3: 'CIV',
    numeric: '384',
    code: '+225',
  },
  {
    country: 'Denmark',
    alpha2: 'DK',
    alpha3: 'DNK',
    numeric: '208',
    code: '+45',
  },
  {
    country: 'Djibouti',
    alpha2: 'DJ',
    alpha3: 'DJI',
    numeric: '262',
    code: '+253',
  },
  {
    country: 'Dominica',
    alpha2: 'DM',
    alpha3: 'DMA',
    numeric: '212',
    code: '+1767',
  },
  {
    country: 'Dominican Republic (the)',
    alpha2: 'DO',
    alpha3: 'DOM',
    numeric: '214',
    code: '+1809, 1829, 1849',
  },
  {
    country: 'Ecuador',
    alpha2: 'EC',
    alpha3: 'ECU',
    numeric: '218',
    code: '+593',
  },
  {
    country: 'Egypt',
    alpha2: 'EG',
    alpha3: 'EGY',
    numeric: '818',
    code: '+20',
  },
  {
    country: 'El Salvador',
    alpha2: 'SV',
    alpha3: 'SLV',
    numeric: '222',
    code: '+503',
  },
  {
    country: 'Equatorial Guinea',
    alpha2: 'GQ',
    alpha3: 'GNQ',
    numeric: '226',
    code: '+240',
  },
  {
    country: 'Eritrea',
    alpha2: 'ER',
    alpha3: 'ERI',
    numeric: '232',
    code: '+291',
  },
  {
    country: 'Estonia',
    alpha2: 'EE',
    alpha3: 'EST',
    numeric: '233',
    code: '+372',
  },
  {
    country: 'Eswatini',
    alpha2: 'SZ',
    alpha3: 'SWZ',
    numeric: '748',
    code: '+268',
  },
  {
    country: 'Ethiopia',
    alpha2: 'ET',
    alpha3: 'ETH',
    numeric: '231',
    code: '+251',
  },
  {
    country: 'Falkland Islands (the) [Malvinas]',
    alpha2: 'FK',
    alpha3: 'FLK',
    numeric: '238',
    code: '+500',
  },
  {
    country: 'Faroe Islands (the)',
    alpha2: 'FO',
    alpha3: 'FRO',
    numeric: '234',
    code: '+298',
  },
  {
    country: 'Fiji',
    alpha2: 'FJ',
    alpha3: 'FJI',
    numeric: '242',
    code: '+679',
  },
  {
    country: 'Finland',
    alpha2: 'FI',
    alpha3: 'FIN',
    numeric: '246',
    code: '+358',
  },
  {
    country: 'France',
    alpha2: 'FR',
    alpha3: 'FRA',
    numeric: '250',
    code: '+33',
  },
  {
    country: 'French Guiana',
    alpha2: 'GF',
    alpha3: 'GUF',
    numeric: '254',
    code: '+594',
  },
  {
    country: 'French Polynesia',
    alpha2: 'PF',
    alpha3: 'PYF',
    numeric: '258',
    code: '+689',
  },
  {
    country: 'French Southern Territories (the)',
    alpha2: 'TF',
    alpha3: 'ATF',
    numeric: '260',
    code: '+262',
  },
  {
    country: 'Gabon',
    alpha2: 'GA',
    alpha3: 'GAB',
    numeric: '266',
    code: '+241',
  },
  {
    country: 'Gambia (the)',
    alpha2: 'GM',
    alpha3: 'GMB',
    numeric: '270',
    code: '+220',
  },
  {
    country: 'Georgia',
    alpha2: 'GE',
    alpha3: 'GEO',
    numeric: '268',
    code: '+995',
  },
  {
    country: 'Germany',
    alpha2: 'DE',
    alpha3: 'DEU',
    numeric: '276',
    code: '+49',
  },
  {
    country: 'Ghana',
    alpha2: 'GH',
    alpha3: 'GHA',
    numeric: '288',
    code: '+233',
  },
  {
    country: 'Gibraltar',
    alpha2: 'GI',
    alpha3: 'GIB',
    numeric: '292',
    code: '+350',
  },
  {
    country: 'Greece',
    alpha2: 'GR',
    alpha3: 'GRC',
    numeric: '300',
    code: '+30',
  },
  {
    country: 'Greenland',
    alpha2: 'GL',
    alpha3: 'GRL',
    numeric: '304',
    code: '+299',
  },
  {
    country: 'Grenada',
    alpha2: 'GD',
    alpha3: 'GRD',
    numeric: '308',
    code: '+1473',
  },
  {
    country: 'Guadeloupe',
    alpha2: 'GP',
    alpha3: 'GLP',
    numeric: '312',
    code: '+590',
  },
  {
    country: 'Guam',
    alpha2: 'GU',
    alpha3: 'GUM',
    numeric: '316',
    code: '+1671',
  },
  {
    country: 'Guatemala',
    alpha2: 'GT',
    alpha3: 'GTM',
    numeric: '320',
    code: '+502',
  },
  {
    country: 'Guernsey',
    alpha2: 'GG',
    alpha3: 'GGY',
    numeric: '831',
    code: '+441481',
  },
  {
    country: 'Guinea',
    alpha2: 'GN',
    alpha3: 'GIN',
    numeric: '324',
    code: '+224',
  },
  {
    country: 'Guinea-Bissau',
    alpha2: 'GW',
    alpha3: 'GNB',
    numeric: '624',
    code: '+245',
  },
  {
    country: 'Guyana',
    alpha2: 'GY',
    alpha3: 'GUY',
    numeric: '328',
    code: '+592',
  },
  {
    country: 'Haiti',
    alpha2: 'HT',
    alpha3: 'HTI',
    numeric: '332',
    code: '+509',
  },
  {
    country: 'Heard Island and McDonald Islands',
    alpha2: 'HM',
    alpha3: 'HMD',
    numeric: '334',
    code: '+672',
  },
  {
    country: 'Holy See (the)',
    alpha2: 'VA',
    alpha3: 'VAT',
    numeric: '336',
    code: '+379',
  },
  {
    country: 'Honduras',
    alpha2: 'HN',
    alpha3: 'HND',
    numeric: '340',
    code: '+504',
  },
  {
    country: 'Hong Kong',
    alpha2: 'HK',
    alpha3: 'HKG',
    numeric: '344',
    code: '+852',
  },
  {
    country: 'Hungary',
    alpha2: 'HU',
    alpha3: 'HUN',
    numeric: '348',
    code: '+36',
  },
  {
    country: 'Iceland',
    alpha2: 'IS',
    alpha3: 'ISL',
    numeric: '352',
    code: '+354',
  },
  {
    country: 'India',
    alpha2: 'IN',
    alpha3: 'IND',
    numeric: '356',
    code: '+91',
  },
  {
    country: 'Indonesia',
    alpha2: 'ID',
    alpha3: 'IDN',
    numeric: '360',
    code: '+62',
  },
  {
    country: 'Iran (Islamic Republic of)',
    alpha2: 'IR',
    alpha3: 'IRN',
    numeric: '364',
    code: '+98',
  },
  {
    country: 'Iraq',
    alpha2: 'IQ',
    alpha3: 'IRQ',
    numeric: '368',
    code: '+964',
  },
  {
    country: 'Ireland',
    alpha2: 'IE',
    alpha3: 'IRL',
    numeric: '372',
    code: '+353',
  },
  {
    country: 'Isle of Man',
    alpha2: 'IM',
    alpha3: 'IMN',
    numeric: '833',
    code: '+441624',
  },
  {
    country: 'Israel',
    alpha2: 'IL',
    alpha3: 'ISR',
    numeric: '376',
    code: '+972',
  },
  {
    country: 'Italy',
    alpha2: 'IT',
    alpha3: 'ITA',
    numeric: '380',
    code: '+39',
  },
  {
    country: 'Jamaica',
    alpha2: 'JM',
    alpha3: 'JAM',
    numeric: '388',
    code: '+1876',
  },
  {
    country: 'Japan',
    alpha2: 'JP',
    alpha3: 'JPN',
    numeric: '392',
    code: '+81',
  },
  {
    country: 'Jersey',
    alpha2: 'JE',
    alpha3: 'JEY',
    numeric: '832',
    code: '+441534',
  },
  {
    country: 'Jordan',
    alpha2: 'JO',
    alpha3: 'JOR',
    numeric: '400',
    code: '+962',
  },
  {
    country: 'Kazakhstan',
    alpha2: 'KZ',
    alpha3: 'KAZ',
    numeric: '398',
    code: '+7',
  },
  {
    country: 'Kenya',
    alpha2: 'KE',
    alpha3: 'KEN',
    numeric: '404',
    code: '+254',
  },
  {
    country: 'Kiribati',
    alpha2: 'KI',
    alpha3: 'KIR',
    numeric: '296',
    code: '+686',
  },
  {
    country: "Korea (the Democratic People's Republic of)",
    alpha2: 'KP',
    alpha3: 'PRK',
    numeric: '408',
    code: '+850',
  },
  {
    country: 'Korea (the Republic of)',
    alpha2: 'KR',
    alpha3: 'KOR',
    numeric: '410',
    code: '+82',
  },
  {
    country: 'Kuwait',
    alpha2: 'KW',
    alpha3: 'KWT',
    numeric: '414',
    code: '+965',
  },
  {
    country: 'Kyrgyzstan',
    alpha2: 'KG',
    alpha3: 'KGZ',
    numeric: '417',
    code: '+996',
  },
  {
    country: "Lao People's Democratic Republic (the)",
    alpha2: 'LA',
    alpha3: 'LAO',
    numeric: '418',
    code: '+856',
  },
  {
    country: 'Latvia',
    alpha2: 'LV',
    alpha3: 'LVA',
    numeric: '428',
    code: '+371',
  },
  {
    country: 'Lebanon',
    alpha2: 'LB',
    alpha3: 'LBN',
    numeric: '422',
    code: '+961',
  },
  {
    country: 'Lesotho',
    alpha2: 'LS',
    alpha3: 'LSO',
    numeric: '426',
    code: '+266',
  },
  {
    country: 'Liberia',
    alpha2: 'LR',
    alpha3: 'LBR',
    numeric: '430',
    code: '+231',
  },
  {
    country: 'Libya',
    alpha2: 'LY',
    alpha3: 'LBY',
    numeric: '434',
    code: '+218',
  },
  {
    country: 'Liechtenstein',
    alpha2: 'LI',
    alpha3: 'LIE',
    numeric: '438',
    code: '+423',
  },
  {
    country: 'Lithuania',
    alpha2: 'LT',
    alpha3: 'LTU',
    numeric: '440',
    code: '+370',
  },
  {
    country: 'Luxembourg',
    alpha2: 'LU',
    alpha3: 'LUX',
    numeric: '442',
    code: '+352',
  },
  {
    country: 'Macao',
    alpha2: 'MO',
    alpha3: 'MAC',
    numeric: '446',
    code: '+853',
  },
  {
    country: 'Madagascar',
    alpha2: 'MG',
    alpha3: 'MDG',
    numeric: '450',
    code: '+261',
  },
  {
    country: 'Malawi',
    alpha2: 'MW',
    alpha3: 'MWI',
    numeric: '454',
    code: '+265',
  },
  {
    country: 'Malaysia',
    alpha2: 'MY',
    alpha3: 'MYS',
    numeric: '458',
    code: '+60',
  },
  {
    country: 'Maldives',
    alpha2: 'MV',
    alpha3: 'MDV',
    numeric: '462',
    code: '+960',
  },
  {
    country: 'Mali',
    alpha2: 'ML',
    alpha3: 'MLI',
    numeric: '466',
    code: '+223',
  },
  {
    country: 'Malta',
    alpha2: 'MT',
    alpha3: 'MLT',
    numeric: '470',
    code: '+356',
  },
  {
    country: 'Marshall Islands (the)',
    alpha2: 'MH',
    alpha3: 'MHL',
    numeric: '584',
    code: '+692',
  },
  {
    country: 'Martinique',
    alpha2: 'MQ',
    alpha3: 'MTQ',
    numeric: '474',
    code: '+596',
  },
  {
    country: 'Mauritania',
    alpha2: 'MR',
    alpha3: 'MRT',
    numeric: '478',
    code: '+222',
  },
  {
    country: 'Mauritius',
    alpha2: 'MU',
    alpha3: 'MUS',
    numeric: '480',
    code: '+230',
  },
  {
    country: 'Mayotte',
    alpha2: 'YT',
    alpha3: 'MYT',
    numeric: '175',
    code: '+262',
  },
  {
    country: 'Mexico',
    alpha2: 'MX',
    alpha3: 'MEX',
    numeric: '484',
    code: '+52',
  },
  {
    country: 'Micronesia (Federated States of)',
    alpha2: 'FM',
    alpha3: 'FSM',
    numeric: '583',
    code: '+691',
  },
  {
    country: 'Moldova (the Republic of)',
    alpha2: 'MD',
    alpha3: 'MDA',
    numeric: '498',
    code: '+373',
  },
  {
    country: 'Monaco',
    alpha2: 'MC',
    alpha3: 'MCO',
    numeric: '492',
    code: '+377',
  },
  {
    country: 'Mongolia',
    alpha2: 'MN',
    alpha3: 'MNG',
    numeric: '496',
    code: '+976',
  },
  {
    country: 'Montenegro',
    alpha2: 'ME',
    alpha3: 'MNE',
    numeric: '499',
    code: '+382',
  },
  {
    country: 'Montserrat',
    alpha2: 'MS',
    alpha3: 'MSR',
    numeric: '500',
    code: '+1664',
  },
  {
    country: 'Morocco',
    alpha2: 'MA',
    alpha3: 'MAR',
    numeric: '504',
    code: '+212',
  },
  {
    country: 'Mozambique',
    alpha2: 'MZ',
    alpha3: 'MOZ',
    numeric: '508',
    code: '+258',
  },
  {
    country: 'Myanmar',
    alpha2: 'MM',
    alpha3: 'MMR',
    numeric: '104',
    code: '+95',
  },
  {
    country: 'Namibia',
    alpha2: 'NA',
    alpha3: 'NAM',
    numeric: '516',
    code: '+264',
  },
  {
    country: 'Nauru',
    alpha2: 'NR',
    alpha3: 'NRU',
    numeric: '520',
    code: '+674',
  },
  {
    country: 'Nepal',
    alpha2: 'NP',
    alpha3: 'NPL',
    numeric: '524',
    code: '+977',
  },
  {
    country: 'Netherlands (the)',
    alpha2: 'NL',
    alpha3: 'NLD',
    numeric: '528',
    code: '+31',
  },
  {
    country: 'New Caledonia',
    alpha2: 'NC',
    alpha3: 'NCL',
    numeric: '540',
    code: '+687',
  },
  {
    country: 'New Zealand',
    alpha2: 'NZ',
    alpha3: 'NZL',
    numeric: '554',
    code: '+64',
  },
  {
    country: 'Nicaragua',
    alpha2: 'NI',
    alpha3: 'NIC',
    numeric: '558',
    code: '+505',
  },
  {
    country: 'Niger (the)',
    alpha2: 'NE',
    alpha3: 'NER',
    numeric: '562',
    code: '+227',
  },
  {
    country: 'Nigeria',
    alpha2: 'NG',
    alpha3: 'NGA',
    numeric: '566',
    code: '+234',
  },
  {
    country: 'Niue',
    alpha2: 'NU',
    alpha3: 'NIU',
    numeric: '570',
    code: '+683',
  },
  {
    country: 'Norfolk Island',
    alpha2: 'NF',
    alpha3: 'NFK',
    numeric: '574',
    code: '+672',
  },
  {
    country: 'Northern Mariana Islands (the)',
    alpha2: 'MP',
    alpha3: 'MNP',
    numeric: '580',
    code: '+1670',
  },
  {
    country: 'Norway',
    alpha2: 'NO',
    alpha3: 'NOR',
    numeric: '578',
    code: '+47',
  },
  {
    country: 'Oman',
    alpha2: 'OM',
    alpha3: 'OMN',
    numeric: '512',
    code: '+968',
  },
  {
    country: 'Pakistan',
    alpha2: 'PK',
    alpha3: 'PAK',
    numeric: '586',
    code: '+92',
  },
  {
    country: 'Palau',
    alpha2: 'PW',
    alpha3: 'PLW',
    numeric: '585',
    code: '+680',
  },
  {
    country: 'Palestine, State of',
    alpha2: 'PS',
    alpha3: 'PSE',
    numeric: '275',
    code: '+970',
  },
  {
    country: 'Panama',
    alpha2: 'PA',
    alpha3: 'PAN',
    numeric: '591',
    code: '+507',
  },
  {
    country: 'Papua New Guinea',
    alpha2: 'PG',
    alpha3: 'PNG',
    numeric: '598',
    code: '+675',
  },
  {
    country: 'Paraguay',
    alpha2: 'PY',
    alpha3: 'PRY',
    numeric: '600',
    code: '+595',
  },
  {
    country: 'Peru',
    alpha2: 'PE',
    alpha3: 'PER',
    numeric: '604',
    code: '+51',
  },
  {
    country: 'Philippines (the)',
    alpha2: 'PH',
    alpha3: 'PHL',
    numeric: '608',
    code: '+63',
  },
  {
    country: 'Pitcairn',
    alpha2: 'PN',
    alpha3: 'PCN',
    numeric: '612',
    code: '+64',
  },
  {
    country: 'Poland',
    alpha2: 'PL',
    alpha3: 'POL',
    numeric: '616',
    code: '+48',
  },
  {
    country: 'Portugal',
    alpha2: 'PT',
    alpha3: 'PRT',
    numeric: '620',
    code: '+351',
  },
  {
    country: 'Puerto Rico',
    alpha2: 'PR',
    alpha3: 'PRI',
    numeric: '630',
    code: '+1787, 1939',
  },
  {
    country: 'Qatar',
    alpha2: 'QA',
    alpha3: 'QAT',
    numeric: '634',
    code: '+974',
  },
  {
    country: 'Republic of North Macedonia',
    alpha2: 'MK',
    alpha3: 'MKD',
    numeric: '807',
    code: '+389',
  },
  {
    country: 'Romania',
    alpha2: 'RO',
    alpha3: 'ROU',
    numeric: '642',
    code: '+40',
  },
  {
    country: 'Russian Federation (the)',
    alpha2: 'RU',
    alpha3: 'RUS',
    numeric: '643',
    code: '+7',
  },
  {
    country: 'Rwanda',
    alpha2: 'RW',
    alpha3: 'RWA',
    numeric: '646',
    code: '+250',
  },
  {
    country: 'Réunion',
    alpha2: 'RE',
    alpha3: 'REU',
    numeric: '638',
    code: '+262',
  },
  {
    country: 'Saint Barthélemy',
    alpha2: 'BL',
    alpha3: 'BLM',
    numeric: '652',
    code: '+590',
  },
  {
    country: 'Saint Helena, Ascension and Tristan da Cunha',
    alpha2: 'SH',
    alpha3: 'SHN',
    numeric: '654',
    code: '+290',
  },
  {
    country: 'Saint Kitts and Nevis',
    alpha2: 'KN',
    alpha3: 'KNA',
    numeric: '659',
    code: '+1869',
  },
  {
    country: 'Saint Lucia',
    alpha2: 'LC',
    alpha3: 'LCA',
    numeric: '662',
    code: '+1758',
  },
  {
    country: 'Saint Martin (French part)',
    alpha2: 'MF',
    alpha3: 'MAF',
    numeric: '663',
    code: '+590',
  },
  {
    country: 'Saint Pierre and Miquelon',
    alpha2: 'PM',
    alpha3: 'SPM',
    numeric: '666',
    code: '+508',
  },
  {
    country: 'Saint Vincent and the Grenadines',
    alpha2: 'VC',
    alpha3: 'VCT',
    numeric: '670',
    code: '+1784',
  },
  {
    country: 'Samoa',
    alpha2: 'WS',
    alpha3: 'WSM',
    numeric: '882',
    code: '+685',
  },
  {
    country: 'San Marino',
    alpha2: 'SM',
    alpha3: 'SMR',
    numeric: '674',
    code: '+378',
  },
  {
    country: 'Sao Tome and Principe',
    alpha2: 'ST',
    alpha3: 'STP',
    numeric: '678',
    code: '+239',
  },
  {
    country: 'Saudi Arabia',
    alpha2: 'SA',
    alpha3: 'SAU',
    numeric: '682',
    code: '+966',
  },
  {
    country: 'Senegal',
    alpha2: 'SN',
    alpha3: 'SEN',
    numeric: '686',
    code: '+221',
  },
  {
    country: 'Serbia',
    alpha2: 'RS',
    alpha3: 'SRB',
    numeric: '688',
    code: '+381',
  },
  {
    country: 'Seychelles',
    alpha2: 'SC',
    alpha3: 'SYC',
    numeric: '690',
    code: '+248',
  },
  {
    country: 'Sierra Leone',
    alpha2: 'SL',
    alpha3: 'SLE',
    numeric: '694',
    code: '+232',
  },
  {
    country: 'Singapore',
    alpha2: 'SG',
    alpha3: 'SGP',
    numeric: '702',
    code: '+65',
  },
  {
    country: 'Sint Maarten (Dutch part)',
    alpha2: 'SX',
    alpha3: 'SXM',
    numeric: '534',
    code: '+1721',
  },
  {
    country: 'Slovakia',
    alpha2: 'SK',
    alpha3: 'SVK',
    numeric: '703',
    code: '+421',
  },
  {
    country: 'Slovenia',
    alpha2: 'SI',
    alpha3: 'SVN',
    numeric: '705',
    code: '+386',
  },
  {
    country: 'Solomon Islands',
    alpha2: 'SB',
    alpha3: 'SLB',
    numeric: '90',
    code: '+677',
  },
  {
    country: 'Somalia',
    alpha2: 'SO',
    alpha3: 'SOM',
    numeric: '706',
    code: '+252',
  },
  {
    country: 'South Africa',
    alpha2: 'ZA',
    alpha3: 'ZAF',
    numeric: '710',
    code: '+27',
  },
  {
    country: 'South Georgia and the South Sandwich Islands',
    alpha2: 'GS',
    alpha3: 'SGS',
    numeric: '239',
    code: '+500',
  },
  {
    country: 'South Sudan',
    alpha2: 'SS',
    alpha3: 'SSD',
    numeric: '728',
    code: '+211',
  },
  {
    country: 'Spain',
    alpha2: 'ES',
    alpha3: 'ESP',
    numeric: '724',
    code: '+34',
  },
  {
    country: 'Sri Lanka',
    alpha2: 'LK',
    alpha3: 'LKA',
    numeric: '144',
    code: '+94',
  },
  {
    country: 'Sudan (the)',
    alpha2: 'SD',
    alpha3: 'SDN',
    numeric: '729',
    code: '+249',
  },
  {
    country: 'Suriname',
    alpha2: 'SR',
    alpha3: 'SUR',
    numeric: '740',
    code: '+597',
  },
  {
    country: 'Svalbard and Jan Mayen',
    alpha2: 'SJ',
    alpha3: 'SJM',
    numeric: '744',
    code: '+47',
  },
  {
    country: 'Sweden',
    alpha2: 'SE',
    alpha3: 'SWE',
    numeric: '752',
    code: '+46',
  },
  {
    country: 'Switzerland',
    alpha2: 'CH',
    alpha3: 'CHE',
    numeric: '756',
    code: '+41',
  },
  {
    country: 'Syrian Arab Republic',
    alpha2: 'SY',
    alpha3: 'SYR',
    numeric: '760',
    code: '+963',
  },
  {
    country: 'Taiwan (Province of China)',
    alpha2: 'TW',
    alpha3: 'TWN',
    numeric: '158',
    code: '+886',
  },
  {
    country: 'Tajikistan',
    alpha2: 'TJ',
    alpha3: 'TJK',
    numeric: '762',
    code: '+992',
  },
  {
    country: 'Tanzania, United Republic of',
    alpha2: 'TZ',
    alpha3: 'TZA',
    numeric: '834',
    code: '+255',
  },
  {
    country: 'Thailand',
    alpha2: 'TH',
    alpha3: 'THA',
    numeric: '764',
    code: '+66',
  },
  {
    country: 'Timor-Leste',
    alpha2: 'TL',
    alpha3: 'TLS',
    numeric: '626',
    code: '+670',
  },
  {
    country: 'Togo',
    alpha2: 'TG',
    alpha3: 'TGO',
    numeric: '768',
    code: '+228',
  },
  {
    country: 'Tokelau',
    alpha2: 'TK',
    alpha3: 'TKL',
    numeric: '772',
    code: '+690',
  },
  {
    country: 'Tonga',
    alpha2: 'TO',
    alpha3: 'TON',
    numeric: '776',
    code: '+676',
  },
  {
    country: 'Trinidad and Tobago',
    alpha2: 'TT',
    alpha3: 'TTO',
    numeric: '780',
    code: '+1868',
  },
  {
    country: 'Tunisia',
    alpha2: 'TN',
    alpha3: 'TUN',
    numeric: '788',
    code: '+216',
  },
  {
    country: 'Turkey',
    alpha2: 'TR',
    alpha3: 'TUR',
    numeric: '792',
    code: '+90',
  },
  {
    country: 'Turkmenistan',
    alpha2: 'TM',
    alpha3: 'TKM',
    numeric: '795',
    code: '+993',
  },
  {
    country: 'Turks and Caicos Islands (the)',
    alpha2: 'TC',
    alpha3: 'TCA',
    numeric: '796',
    code: '+1649',
  },
  {
    country: 'Tuvalu',
    alpha2: 'TV',
    alpha3: 'TUV',
    numeric: '798',
    code: '+688',
  },
  {
    country: 'Uganda',
    alpha2: 'UG',
    alpha3: 'UGA',
    numeric: '800',
    code: '+256',
  },
  {
    country: 'Ukraine',
    alpha2: 'UA',
    alpha3: 'UKR',
    numeric: '804',
    code: '+380',
  },
  {
    country: 'United Arab Emirates (the)',
    alpha2: 'AE',
    alpha3: 'ARE',
    numeric: '784',
    code: '+971',
  },
  {
    country: 'United Kingdom of Great Britain and Northern Ireland (the)',
    alpha2: 'GB',
    alpha3: 'GBR',
    numeric: '826',
    code: '+44',
  },
  {
    country: 'United States Minor Outlying Islands (the)',
    alpha2: 'UM',
    alpha3: 'UMI',
    numeric: '581',
    code: '+1',
  },
  {
    country: 'United States of America (the)',
    alpha2: 'US',
    alpha3: 'USA',
    numeric: '840',
    code: '+1',
  },
  {
    country: 'Uruguay',
    alpha2: 'UY',
    alpha3: 'URY',
    numeric: '858',
    code: '+598',
  },
  {
    country: 'Uzbekistan',
    alpha2: 'UZ',
    alpha3: 'UZB',
    numeric: '860',
    code: '+998',
  },
  {
    country: 'Vanuatu',
    alpha2: 'VU',
    alpha3: 'VUT',
    numeric: '548',
    code: '+678',
  },
  {
    country: 'Venezuela (Bolivarian Republic of)',
    alpha2: 'VE',
    alpha3: 'VEN',
    numeric: '862',
    code: '+58',
  },
  {
    country: 'Viet Nam',
    alpha2: 'VN',
    alpha3: 'VNM',
    numeric: '704',
    code: '+84',
  },
  {
    country: 'Virgin Islands (British)',
    alpha2: 'VG',
    alpha3: 'VGB',
    numeric: '92',
    code: '+1284',
  },
  {
    country: 'Virgin Islands (U.S.)',
    alpha2: 'VI',
    alpha3: 'VIR',
    numeric: '850',
    code: '+1340',
  },
  {
    country: 'Wallis and Futuna',
    alpha2: 'WF',
    alpha3: 'WLF',
    numeric: '876',
    code: '+681',
  },
  {
    country: 'Western Sahara',
    alpha2: 'EH',
    alpha3: 'ESH',
    numeric: '732',
    code: '+212',
  },
  {
    country: 'Yemen',
    alpha2: 'YE',
    alpha3: 'YEM',
    numeric: '887',
    code: '+967',
  },
  {
    country: 'Zambia',
    alpha2: 'ZM',
    alpha3: 'ZMB',
    numeric: '894',
    code: '+260',
  },
  {
    country: 'Zimbabwe',
    alpha2: 'ZW',
    alpha3: 'ZWE',
    numeric: '716',
    code: '+263',
  },
  {
    country: 'Åland Islands',
    alpha2: 'AX',
    alpha3: 'ALA',
    numeric: '248',
    code: '+358',
  },
]
